import React from 'react';
import Skeleton from 'react-loading-skeleton';
import {
  Container, Row, Column,
} from 'globalStyle';

export const Loading = () => (
  <Container>
    <Container mb={80} sm="70%" md="50%" lg="50%" mt={50}>
      <Skeleton height={130} />
    </Container>

    <Skeleton height={230} style={{ marginBottom: '80px' }} />
    <Row mb={80}>
      <Column col={3} space={20}>
        <Skeleton height={150} />
      </Column>
      <Column col={9}>
        <Skeleton count={5} />
      </Column>
    </Row>
    <Row mb={60} content="center" allRight={15}>
      <Column col={3}>
        <Skeleton width={80} height={80} />
      </Column>
      <Column col={7}>
        <Skeleton count={3} />
      </Column>
    </Row>
  </Container>
);
